import { faQuestion, faUserPlus } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { Flex } from 'rebass'
import splash from '../../media/classroomSplash.jpg'
import { ReactComponent as QuoteIcon } from '../../media/icon-science.svg'
import oftmcssLogo from '../../media/oftmcss.svg'
import { clearSession, hasInvalidSession } from 'session'
import { IStoreState } from '../../store'
import { Brand, Content, Form, Modal, Templates } from 'ui'
import { LoginFormConnected } from '../../Forms'
import { randomTestimonial } from './testimonials'

/**
 * A basic login form to sign into the application (applies to all user types).
 */
const LoginViewComponent: React.FC<{
  clearInvalidSession: () => any
  sessionLost: boolean
}> = ({ clearInvalidSession, sessionLost }) => {
  const testimonial = randomTestimonial()
  const handleDismiss = () => {
    clearInvalidSession()
    return
  }

  return (
    <Templates.SplashImageView
      backgroundImageSrc={splash}
      footerImageSrc={oftmcssLogo}
      splashContent={
        <Templates.SplashQuote
          quote={testimonial.quote}
          author={testimonial.author}
          title={testimonial.title}
          icon={
            <QuoteIcon
              style={{
                width: 'auto',
                height: '60px',
                display: 'block',
              }}
              className="fill-current text-white"
            />
          }
        />
      }
    >
      <Helmet>
        <title>Login to Your Account - MCSS PRO Connect</title>
      </Helmet>
      <Content.Region>
        <Brand.EpcLogo />
        <Content.Heading>Log In</Content.Heading>
        <LoginFormConnected />
        <Content.List>
          <Content.ListItem>
            <Content.ListIcon>
              <FontAwesomeIcon icon={faQuestion} />
            </Content.ListIcon>
            <Content.Link to="/login/forgot">
              Forgot your password?
            </Content.Link>
          </Content.ListItem>
          <Content.ListItem>
            <Content.ListIcon>
              <FontAwesomeIcon icon={faUserPlus} />
            </Content.ListIcon>
            <Content.Link to="/">Sign Up Today.</Content.Link>
          </Content.ListItem>
        </Content.List>
        {sessionLost ? (
          <Modal.View onDismiss={handleDismiss}>
            <Flex flexDirection="column" p={4} paddingTop={0}>
              <Content.HeadingSmall>
                Your Session Has Expired
              </Content.HeadingSmall>
              <Content.Body>
                Whoops! It looks like we couldn't keep you signed in. This may
                be becuase you signed in on another device or that it's just
                been too long since you've last logged in. Don't worry - it's
                easy to solve. You'll just need to sign in again to access the
                system.
              </Content.Body>
              <Form.ButtonGroup direction="row">
                <Form.Button onClick={handleDismiss}>
                  <span>Okay, I Will Login</span>
                </Form.Button>
              </Form.ButtonGroup>
            </Flex>
          </Modal.View>
        ) : null}
      </Content.Region>
    </Templates.SplashImageView>
  )
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    clearInvalidSession: () => {
      dispatch(clearSession({ invalidSession: false }))
    },
  }
}

const mapStateToProps = (state: IStoreState) => ({
  sessionLost: hasInvalidSession(state.session),
})

export const LoginView = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginViewComponent)
